import React, { useState } from "react";

import { AiOutlineCloudUpload } from "react-icons/ai";
import { fileURL, InputFile } from "../../ApiS";
import { Col, Row } from "../../ApiS/Grid-system/Grid-system";

interface Image {
  id?: string;
  url?: string;
  name?: string;
  value?: string;
}

interface AddFileProps {
  id?: string;
  title?: string;
  name: string;
  type?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  newImages: Image[];
  setnewImages: React.Dispatch<React.SetStateAction<InputFile[]>>;
  setImagesToSend: React.Dispatch<
    React.SetStateAction<{ [key: string]: File }>
  >;
  setOldImages?: React.Dispatch<React.SetStateAction<{}>>;
  images: Image[];
  viewImages: Image[];
  setViewImages: React.Dispatch<React.SetStateAction<InputFile[]>>;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  setUserImages: React.Dispatch<React.SetStateAction<Image[]>>;
  formData: any;
  counter: number;
  setCounter: React.Dispatch<React.SetStateAction<number>>;
  imagesToSend: { [key: string]: File };
}

const AddFiles: React.FC<AddFileProps> = ({
  id,
  title,
  name,
  onChange,
  newImages,
  setnewImages,
  setImagesToSend,
  images,
  setFormData,
  setUserImages,
  formData,
  counter,
  setCounter,
  imagesToSend,
}) => {
  const limit = (images?.length || 0) + (newImages?.length || 0);
  const slots = [];
  let imagesTemp: { [key: string]: File } = {};
  let counterTemp = 0;
  let index = 0;

  for (let i = 0; i < 4 - limit; i++) {
    slots[i] = i;
  }

  const [pdfFiles, setPdfFiles] = useState<InputFile[]>([]);
  const [pdfFilesToSend, setPdfFilesToSend] = useState<{ [key: string]: File }>(
    {}
  );

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      const filesArray = Array.from(event.target.files);

      filesArray.forEach((file) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onloadend = () => {
          const fileObject: InputFile = {
            name: file.name,
            value: reader.result as string,
            type: file.type,
          };

          if (file.type === "pdf") {
            setPdfFiles((prev: InputFile[]) => [...prev, fileObject]);
            setPdfFilesToSend((prev) => ({
              ...prev,
              [`pdfs[${Object.keys(pdfFilesToSend).length}]`]: file,
            }));
          } else {
            setnewImages((prev: InputFile[]) => [...prev, fileObject]);
            setImagesToSend((prev) => ({
              ...prev,
              [`images[${Object.keys(imagesToSend).length}]`]: file,
            }));
          }
        };
      });
    }
  };

  return (
    <div className="my-1">
      <div className="font-bold text-Secondary text-lg">{title}</div>
      <div
        onClick={() => document.getElementById(id || "image")?.click()}
        className={`w-full flex justify-between text-Dark shadow-3 shadow-black border-2 my-2 py-[9px] rounded-xl border-Main px-5 cursor-pointer mx-1 `}
      >
        <div>{title || "أضف صورة أو PDF"}</div>
        <div>
          <AiOutlineCloudUpload size={22} />
        </div>
      </div>
      <input
        id={id || "image"}
        type="file"
        name={name}
        onChange={handleFileChange}
        className="hidden"
        accept="image/*,application/pdf"
        // multiple
        // disabled={limit >= 4}
      />
      <Row className="!mt-6">
        <Col
          col={12}
          className="gap-4 mx-auto w-full flex justify-center flex-wrap"
        >
          {newImages?.length > 0 &&
            newImages.map((e) => (
              <Col key={e.name} className="max-md:w-[40%]">
                <div className="relative border-2 border-Secondary rounded-lg">
                  <span
                    onClick={() => {
                      setnewImages((prev) =>
                        prev.filter((image) => image.value !== e.value)
                      );
                      for (const [key, value] of Object.entries(imagesToSend)) {
                        if (value.name === e.name && counterTemp < 1) {
                          counterTemp = counterTemp + 1;
                          continue;
                        }
                        imagesTemp[`files[${index}]`] = value;
                        index++;
                      }
                      counterTemp = 0;
                      setImagesToSend(imagesTemp);
                    }}
                    className="bg-red-700 w-6 h-6 flex justify-center items-center font-bold text-white cursor-pointer z-10 -top-2 rounded-full absolute"
                  >
                    X
                  </span>
                  <img
                    src={e.value}
                    alt=""
                    className="object-cover rounded-lg md:w-40 h-40 w-full"
                  />
                </div>
              </Col>
            ))}

          {images?.length > 0 &&
            images?.map((e) => (
              <Col key={e.id} className="max-md:w-[40%]">
                <div className="relative border-2 border-Secondary rounded-lg">
                  <span
                    onClick={() => {
                      setFormData((prev: any) => ({
                        ...prev,
                        [`delete_images[${counter}]`]: `${e.id}`,
                      }));
                      setCounter(counter + 1);
                      setUserImages((prev) =>
                        prev.filter((image) => image.id !== e.id)
                      );
                    }}
                    className="bg-red-700 w-6 h-6 flex justify-center items-center font-bold text-white cursor-pointer z-10 -top-2 rounded-full absolute"
                  >
                    X
                  </span>
                  <img
                    src={ images?.length > 0 ? fileURL+  e.url : ""}
                    // alt="Old Profile Pic"
                    className="object-cover rounded-lg md:w-40 h-40 w-full"
                  />
                </div>
              </Col>
            ))}

          {pdfFiles.map((pdf, index) => (
            <Col key={index} className="max-md:w-[40%]">
              <div className="relative border-2 border-Secondary rounded-lg p-4">
                <span
                  onClick={() => {
                    setPdfFiles((prev) =>
                      prev.filter((file) => file.value !== pdf.value)
                    );
                    const updatedPdfFilesToSend: { [key: string]: File } = {};
                    Object.entries(pdfFilesToSend).forEach(([key, value]) => {
                      if (value.name !== pdf.name) {
                        updatedPdfFilesToSend[key] = value;
                      }
                    });
                    setPdfFilesToSend(updatedPdfFilesToSend);
                  }}
                  className="bg-red-700 w-6 h-6 flex justify-center items-center font-bold text-white cursor-pointer z-10 -top-2 rounded-full absolute"
                >
                  X
                </span>
                <div className="text-center">
                  <AiOutlineCloudUpload size={32} />
                  <p className="mt-2">{pdf.name}</p>
                </div>
              </div>
            </Col>
          ))}

          {/* {slots.map((e) => (
            <Col key={e} className="max-md:!w-[40%]">
              <div className="rounded-lg md:w-40 h-40 w-full border-2 border-gray-400"></div>
            </Col>
          ))} */}
        </Col>
      </Row>
    </div>
  );
};

export default AddFiles;
